module.exports = "<app-widgets-summary object=$ctrl.poi type=poi></app-widgets-summary> <app-widgets-review-info-view object=$ctrl.poi></app-widgets-review-info-view> <app-widgets-transitions object=$ctrl.poi kind=\"'poi'\" hide-edit-button=$ctrl.hideEditButton() object-versions=$ctrl.poiVersions> </app-widgets-transitions> <app-poi-view-navbar poi-type=$ctrl.poi.type></app-poi-view-navbar> <ui-view></ui-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/component_partial.html
// module id = 448
// module chunks = 0